import { Component, OnInit, ViewChild } from "@angular/core";
import { SimpleModalComponent } from "ngx-simple-modal";
import { NmsWizardComponent, NmsWizardStepMapData } from "@nms-angular-toolkit/nms-wizard";
import { MuxDemux, MuxDemuxModal } from "../mux-demux.model";
import { MuxDemuxService } from "../services/mux-demux.service";

/**
 * Componente responsável por renderizar a modal para adicionar Mux/Demux.
 */
@Component({
    selector: "add-mux-demux-modal",
    templateUrl: "./add-mux-demux-modal.component.html",
    styleUrls: ["./add-mux-demux-modal.component.scss"]
})
export class AddMuxDemuxModalComponent extends SimpleModalComponent<MuxDemuxModal, any> implements MuxDemuxModal, OnInit {
    @ViewChild(NmsWizardComponent)
    nmsWizard: NmsWizardComponent;
    wizardStepsCacheMap: NmsWizardStepMapData = {};
    muxDemuxInfo: MuxDemux;
    pageTitle: string = "add.mux.demux.modal.title";

    constructor(private readonly muxDemuxService: MuxDemuxService) {
        super();
        this.muxDemuxService.closeModalEmmiter.subscribe(() => this.close());
    }

    ngOnInit() {
        if (this.muxDemuxInfo) {
            this.pageTitle = this.muxDemuxInfo.name ? "edit.mux.demux.modal.title" : this.pageTitle;
            this.wizardStepsCacheMap = this.muxDemuxService.buildCacheMap(this.muxDemuxInfo);
        }
    }

    cancel(): void {
        this.close();
    }
}
